import fetchAPI from '../fetchAPI';

export const callStartNegotiatorReport = async (payload: {
  companyId?: string;
  startDate: string;
  endDate: string;
  password?: string;
}): Promise<iResponse<{ jobId?: string; jobIds?: string[]; status: string; totalCompanies?: number }>> => {
  const response = await fetchAPI<{ jobId?: string; jobIds?: string[]; status: string; totalCompanies?: number }>({
    method: 'POST',
    route: 'artifacts',
    data: { ...payload, kind: 'negotiator' }
  });
  return response;
};

export default callStartNegotiatorReport;
